<form [formGroup]="form">
  <!--Site org path form -->
  <ng-container *avnAsyncData="''; state: siteOrgPathDefState$ | async; loaderType: 'linear'; emptyTemplate: errorTemplate; errorTemplate: errorTemplate">
    <ng-container *ngIf="hasOrgPath; else noOrgPathForm">
      <!-- Organizational Path -->
      <form formGroupName="tags">
        <ng-container>
          <amp-orgpath-form-group
            [attr.data-e2e]="'org-path-form-group'"
            [tagDefinition]="tagDefinition$ | async"
            [nodeDefinition]="siteOrgPathDef$ | async"
            [editable]="true"
            [controlAsyncValidatorMap]="controlAsyncValidatorMap"
            (formChanged)="tagFormValueChanged()"
          >
          </amp-orgpath-form-group>
        </ng-container>
      </form>
      <avn-form-field>
        <ng-container *ngIf="form.controls?.tags?.value | applyFunction : orgPathErrors : [] : this as errors">
          <avn-form-field-error
            [attr.data-e2e]="'duplicate-error'"
            key="duplicate"
            [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.DUPLICATE_100' | transloco"
            *ngIf="errors['duplicate']"
            class="warning-message"
            [style.display]="'inherit'"
          >
            {{ 'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.DUPLICATE_100' | transloco }}
          </avn-form-field-error>
        </ng-container>
      </avn-form-field>
    </ng-container>
  </ng-container>

  <!-- Site Name Input -->
  <ng-template #noOrgPathForm>
    <avn-form-field *ngIf="form.controls.name">
      <avn-input formControlName="name" [attr.data-e2e]="'name-input'" [label]="siteMonitoringFacade.getColumnLabel(SiteProperties.Name) | async"> </avn-input>

      <avn-form-field-hint
        [attr.data-e2e]="'name-hint'"
        [style.display]="['WARNING', 'PENDING'].includes(nameControlStatus$ | async) ? 'none' : 'inherit'"
        [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.HINT_100' | transloco"
      ></avn-form-field-hint>
      <avn-form-field-error
        key="required"
        [attr.data-e2e]="'required-error'"
        [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.REQUIRED_150' | transloco">
      </avn-form-field-error>
      <avn-form-field-error key="minlength" [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.MIN_LENGTH_50' | transloco : { number: MIN_CHAR }"></avn-form-field-error>

      <div class="loading-icon" *ngIf="(nameControlStatus$ | async) === 'PENDING'">
        <avn-icon
          class="icon"
          [attr.data-e2e]="'autorenew-icon'"
          [icon]="'action:autorenew'"
          [fontSize]="14"
          [rotate]="true">
        </avn-icon>
      </div>
      <span class="warning-message"
            [attr.data-e2e]="'warning-message'"
            [style.display]="(nameControlStatus$ | async) === 'WARNING' ? 'inherit' : 'none'">
        {{ 'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.NAME.VALIDATION.DUPLICATE_100' | transloco }}
      </span>
    </avn-form-field>
  </ng-template>

  <avn-form-field>
    <avn-input
      #externalId
      formControlName="externalId"
      [attr.data-e2e]="'external-id'"
      [label]="siteMonitoringFacade.getColumnLabel(SiteProperties.ExternalId) | async"
      [placeholder]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.EXTERNAL_ID.PLACEHOLDER_100' | transloco"
    >
    </avn-input>
    <avn-form-field-error
      key="duplicate"
      [attr.data-e2e]="'duplicate-external-id'"
      [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.EXTERNAL_ID.VALIDATION.DUPLICATE_100' | transloco"></avn-form-field-error>
    <avn-form-field-hint
      [attr.data-e2e]="'external-id-hint'"
      [message]="'siteManagementScope.SITE_MANAGEMENT.SITE_PROPERTIES.EXTERNAL_ID.VALIDATION.HINT_100' | transloco"></avn-form-field-hint>
  </avn-form-field>
</form>

<ng-template #errorTemplate>
  <div class="no-data">
    <avn-empty-data-message
      icon="alert:error"
      [attr.data-e2e]="'error-template'"
      [text]="'siteManagementScope.SITE_MANAGEMENT.BOARD_EDITOR.ERRORS.ORG_PATH.MISSING_DEFINITION_DESCRIPTION_100' | transloco"
      [subText]="'siteManagementScope.SITE_MANAGEMENT.BOARD_EDITOR.ERRORS.ORG_PATH.MISSING_DEFINITION_DESCRIPTION_100' | transloco"
    >
    </avn-empty-data-message>
  </div>
</ng-template>
